<div class="phone-input-wrapper" [class.phone-input-disabled]="isDisabled()">
  <div class="phone-input-country">
    <mat-select
      [value]="selectedCountry()"
      [compareWith]="compareCountry"
      [disabled]="isDisabled()"
      (selectionChange)="onCountryChange($event.value)"
      panelClass="phone-input-country-panel"
    >
      <mat-select-trigger>
        @if (selectedCountry(); as country) {
          <span class="phone-input-flag">{{ country.flag }}</span>
          <span class="phone-input-country-code-name">+{{ country.dialCode }}</span>
        }
      </mat-select-trigger>
      @for (country of countries(); track country.iso2) {
        <mat-option [value]="country">
          <span class="phone-input-flag">{{ country.flag }}</span>
          <span class="phone-input-country-code-name">+{{ country.dialCode }} {{ country.name }}</span>
        </mat-option>
      }
    </mat-select>
  </div>
  <input
    class="phone-input-national"
    type="tel"
    inputmode="tel"
    [placeholder]="placeholder()"
    [disabled]="isDisabled()"
    [value]="nationalNumber()"
    (input)="onNationalInput($event)"
    (blur)="onBlur()"
  />
</div>
